import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import store from './redux/store';
import Login from './components/Auth/Login';
import AdminLayout from './components/AdminLayout';
import Dashboard from './components/Dashboard/Dashboard';
import JobsList from './components/Jobs/JobsList';
import UsersList from './components/Users/UsersList';
import EmployersList from './components/Employers/EmployersList';
import EmployersManager from './components/Employers/EmployersManager';
import ApplicationsList from './components/Applications/ApplicationsList';
import ConversationsList from './components/Conversations/ConversationsList';
import BrandSettings from './components/Appearance/BrandSettings';
import SecurityPanel from './components/Security/SecurityPanel';
import AnalyticsPage from './components/Analytics/AnalyticsPage';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename="/panel">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <JobsList />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <UsersList />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employers"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <EmployersList />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employers-manager"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <EmployersManager />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/applications"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ApplicationsList />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/conversations"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ConversationsList />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/appearance"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <BrandSettings />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AnalyticsPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/security"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <SecurityPanel />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
